export default "__VITE_ASSET__DXWdLso0__"